import { useMemo } from 'react'
import { Property } from '../../../api/properties/types/response'
import { propertyExportValidation } from '../../../common/forms/generalRealEstate/validations'

export const usePropertyExportFormConfig = (data?: Property | null) => {
    const exportValidationConfig = useMemo(() => propertyExportValidation(data), [data])

    return { exportValidationConfig }
}
